<script setup lang="ts">
    const appStore = useAppStore();
    const { website } = storeToRefs(appStore);
    const { generateStringOnlyURL } = useURL();

    const additionalLinkUrl = computed(() => {
        if (!website.value?.shop?.additional_link) return;
        return generateStringOnlyURL(website.value?.shop?.additional_link);
    });

    const icon = computed(() => website.value?.shop?.additional_link_icon?.data?.icon || 'woom-icon-help-bubble');
    const label = computed(() => website.value?.shop?.additional_link?.label);
</script>

<template>
    <nuxt-link
        v-if="label && additionalLinkUrl"
        :to="additionalLinkUrl"
        class="atm-additional-link-button gap-3 text-base transition-colors hover:text-woom-red max-lg:flex max-lg:items-center max-lg:py-3 lg:p-1">
        {{ label }}
    </nuxt-link>
</template>
